
import { css } from '@emotion/react';
import {
    breakpoints,
    colors,
    fontWeights,
    gutterSizes,
    mediaQuery,
} from '@gumtree/ui-library/src/base/theme';

const labelCheckedStyle = css`
    & + label {
        &:before {
            background: ${colors.blue};
            border-color: ${colors.blue};
        }
    }
`;

export const RadioButtonStyle = (isVisible: boolean) => css`
    ${isVisible ? '' : 'display: none;'}
    & label:hover {
        cursor: pointer;
    }

    & > input {
        & + label {
            padding: 0 0 0 27px;
            margin-bottom: ${gutterSizes.medium};
            font-weight: ${fontWeights.normal};
            color: ${colors.bark};

            &:hover {
                cursor: pointer;
            }

            a {
                color: ${colors.bark};
            }

            &:before {
                width: ${gutterSizes.large};
                height: ${gutterSizes.large};
                border: 2px solid ${colors.bark60};
                box-shadow: 0 0 0 2px ${colors.white} inset;
                margin-top: 0;
                top: 0;
            }
        }

        &:checked {
            ${labelCheckedStyle}
        }

        ${mediaQuery.from(breakpoints.xlarge)} {
            &:hover {
                ${labelCheckedStyle}
            }
        }
    }
`;
